import {ThemeProvider} from "@zendeskgarden/react-theming";
import {ReactElement, useContext, useEffect, useState} from "react";
import {ViziblyTheme} from "../../styles/zendesk-garden/ViziblyZDGTheme";
import {Col, Grid, Row} from "@zendeskgarden/react-grid";
import {Field, Input, InputGroup} from "@zendeskgarden/react-forms";
import {Button} from "@zendeskgarden/react-buttons";
import {GuestAuthenticationContext} from "../../contexts/guest-auth-context/GuestAuthContext";
import loginGraphic from "./loginGraphic";
import logo from "../../assets/images/logo/vizibly.svg";
import {isGuestPasswordAccessFromURL} from "../../libs/guest_token";

import {useHistory} from "react-router-dom";
import * as css from "./styles/guestOtp.module.scss";

export function GuestOtp(): ReactElement {
    const guestAuthContext = useContext(GuestAuthenticationContext);
    const history = useHistory();
    const [otp, setOtp] = useState<string>();
    const [codeSent, setCodeSent] = useState(false);
    const [password, setPassword] = useState<string>("");
    const [passwordAccess] = useState(() => isGuestPasswordAccessFromURL());

    function handleSendCode() {
        setCodeSent(true);
        guestAuthContext.requestOTP();
    }

    useEffect(() => {
        if (guestAuthContext.user) {
            history.push("/guest");
        }
    }, [guestAuthContext.user]);

    return (
        <ThemeProvider theme={ViziblyTheme}>
            <Grid>
                <Row>
                    <Col className={css.otpWrapper} size={3} offset={3}>
                        <span className={css.welcome}>Welcome to</span>
                        <img src={logo} className={css.logo}/>
                        {passwordAccess ?
                        <>
                            <span className={css.prompt}>Enter the password you received to continue.</span>
                            <Field>
                                <InputGroup>
                                    <Input
                                        type="text"
                                        value={password}
                                        onChange={evt => setPassword(evt.target.value)}
                                        onKeyDown={evt => {
                                            if (evt.key === "Enter" && password) {
                                                guestAuthContext.signInWithPassword(password);
                                            }
                                        }}
                                    />
                                    <Button disabled={!password} onClick={() => guestAuthContext.signInWithPassword(password)}>Sign In</Button>
                                </InputGroup>
                            </Field>
                            {guestAuthContext.passwordSignInFailed &&
                                <span className={css.error}>Invalid password. Ask the person who shared this report for a new link and password.</span>
                            }
                        </>
                        :
                        <>
                            {!codeSent &&
                            <>
                                <span className={css.prompt}>To sign in, click <strong>Send Code</strong>. We’ll email you a code.</span>
                                <Button className={css.sendButton} isPrimary size="large" onClick={handleSendCode}>Send Code</Button>
                            </>
                            }
                            {codeSent &&
                            <>
                                <span className={css.prompt}>Please check your email and paste 6-digit code here</span>
                                <Field>
                                    <InputGroup>
                                        <Input type="text" value={otp} onChange={evt => setOtp(evt.target.value)}></Input>
                                        <Button disabled={!otp} onClick={() => otp && guestAuthContext.signInWithOTP(otp)}>Sign In</Button>
                                    </InputGroup>
                                </Field>
                            </>
                            }
                        </>
                        }
                    </Col>
                    <Col className={css.otpRight} size={3}>
                        <img src={loginGraphic} alt="assestsPerformance"/>
                        <div className="optimize-text">Optimize the performance of <br/> your assets.</div>
                </Col>
                </Row>
            </Grid>
        </ThemeProvider>
    );
}
